import * as React from 'react';
import Section from '../../components/Section';
import { Text, CountrySelect } from '../../components/forms';
import HelpHint from '../../components/HelpHint';
import { Company } from '../../company';

type Props = {
  company: Company;
  onChange: Function;
};

const setLocationValue = (obj: Company, onChange: Function) => (
  field: string,
  newValue: String,
) =>
  onChange(
    Object.assign({}, obj, {
      location: {
        ...obj.location,
        [field]: newValue,
      },
    }),
  );

export default function CompanyLocation(props: Props) {
  return (
    <Section title="Address">
      <div className="flex flex-wrap">
        <div className="flex-auto w-70-l w-100 pr2">
          <Text
            label="Address Line 1"
            field={['address_line_1']}
            id="address_line_1"
            defaultValue={props.company.location.address_line_1}
            onValueChange={setLocationValue(props.company, props.onChange)}
          />
          <Text
            label="Address Line 2"
            field={['address_line_2']}
            id="address_line_2"
            defaultValue={props.company.location.address_line_2}
            onValueChange={setLocationValue(props.company, props.onChange)}
          />
          <Text
            label="Address Line 3"
            field={['address_line_3']}
            id="address_line_3"
            defaultValue={props.company.location.address_line_3}
            onValueChange={setLocationValue(props.company, props.onChange)}
          />
          <Text
            label="City"
            field={['city']}
            id="city"
            defaultValue={props.company.location.city}
            onValueChange={setLocationValue(props.company, props.onChange)}
          />
          <Text
            label="State"
            field={['county']}
            id="county"
            defaultValue={props.company.location.county}
            onValueChange={setLocationValue(props.company, props.onChange)}
          />
          <CountrySelect
            label="Country"
            field={['country']}
            id="country"
            defaultValue={props.company.location.country}
            onValueChange={setLocationValue(props.company, props.onChange)}
          />
          <Text
            label="Postal Code"
            field={['postal_code']}
            id="postal_code"
            defaultValue={props.company.location.postal_code}
            onValueChange={setLocationValue(props.company, props.onChange)}
          />
        </div>
        <div className="flex-auto w-30-l w-100 pl2">
          <HelpHint>
            Note: Contact email address will be used for any new order
            notifications
          </HelpHint>
        </div>
      </div>
    </Section>
  );
}
